































import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import messages from '@/static/messages.json';
import {Button} from '@/components/Base';
import Box from '@/components/Shared/Box';

@Component({
  components: {
    Box,
    Button,
  },
})
export default class InvitationBox extends Vue {
  public invitationKey: string = '';
  public messages: any = messages;

  @Action public clearInvitationKeyError: void;
  @Getter public invitationKeyErrorMessage?: string | null;
  @Getter public processingInvitationKey: boolean;

  public submitInvitationKey() {
    const $this: any = this;

    $this.$validator.validateAll().then((success: any) => {
      if (!success) {
        return false;
      }
      this.$store.dispatch('postInvitationKey', this.invitationKey);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InvitationBox/InvitationBox.vue